import { Helmet } from "react-helmet";
import LandingNav from "./LandingNav";
import LandingFooter from "./LandingFooter";
import useLandingTheme from "./useLandingTheme";
import { FREE_PRODUCT_LIMIT, PRO_TRIAL_DAYS } from "../../plans";
import Seo from "../Seo";
import "../../landing.css";

const perks = [
    `Gratis hasta ${FREE_PRODUCT_LIMIT} productos, sin tarjeta`,
    "Tu QR listo para imprimir",
    "Cambiás precios y se ven al instante",
    `Pro con ${PRO_TRIAL_DAYS} días de prueba gratis`
];

// Marco de las páginas de ingreso y registro, con el mismo estilo que la landing.
const AuthLayout = ({ title, description, path, noindex, eyebrow, heading, subheading, children }) => {

    const { dark, toggleTheme } = useLandingTheme();

  return (
    <div className="lp" data-theme={dark ? "dark" : "light"}>
        <Seo title={title} description={description} path={path} noindex={noindex}></Seo>
        <Helmet>
            <body className={dark ? "lp-body lp-body-dark" : "lp-body"} />
            <meta name="theme-color" content={dark ? "#120b14" : "#fbfaf7"} />
        </Helmet>

        <LandingNav dark={dark} onToggleTheme={toggleTheme}></LandingNav>

        <main className="lp-auth">
            <div className="lp-hero-bg" aria-hidden="true">
                <span className="lp-blob lp-blob-1"></span>
                <span className="lp-blob lp-blob-2"></span>
            </div>

            <aside className="lp-auth-side lp-hero-intro">
                <span className="lp-eyebrow">{eyebrow}</span>
                <h1>{heading}</h1>
                <p className="lp-lead">{subheading}</p>
                <ul className="lp-auth-perks">
                    {
                        perks.map(perk => (
                            <li key={perk}>
                                <svg aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12.5l4.5 4.5L19 7"></path></svg>
                                {perk}
                            </li>
                        ))
                    }
                </ul>
            </aside>

            <section className="lp-auth-card lp-hero-intro">
                {children}
            </section>
        </main>

        <LandingFooter></LandingFooter>
    </div>
  )
}

export default AuthLayout
